//#region src/extensions/link-extension/url-scheme.ts
var e = {
	https: "https://",
	mailto: "mailto:",
	tel: "tel:"
};
//#endregion
export { e as URL_SCHEMES };
